import React from 'react';
import { Typography, Divider } from 'antd';
import '../../../Styles/ResearchLabs.css'; // Create and import this CSS file for styling
import investigatorImage from '../../../Assets/ResearchLabs/ARSL/Director/adnan.png'; // Replace with actual image
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

const ArslHead = () => {
  return (
     <section className="principal-investigator-section">
    <div className="investigator-content">
      <Title level={2} className="investigator-title">Principal Investigator/Lab Director</Title>
      <Divider className="ncgsa-divider" />
      <img className="investigator-photo" src={investigatorImage} alt="Dr. Muhammad Adnan Shahid" />
      <Text strong className="investigator-name">Dr. Muhammad Adnan Shahid
</Text>
      <Text className="investigator-affiliation">University of Agriculture, Faisalabad.
</Text>
      <Link className="investigator-contact" href="mailto:muhammad.shahid@uaf.edu.pk">muhammad.shahid@uaf.edu.pk</Link>
      <Link className="investigator-contact" href="tel:041-9200161-70 Ext 3010">Phone: 041-9200161-70 Ext 3010</Link>
    </div>
  </section>
  );
};

export default ArslHead;;
